import { Tools } from '@/plugins/tools'
import BigNumber from 'bignumber.js'
import { Contract, ethers } from 'ethers'
import ABI from '../abi/HappyRedPacket.json'
import { HappyRedPacket } from '../helper/abi/HappyRedPacket'
import { ContractType, ContractUtils } from './common'
import { TokenContract } from './token'

interface ICreateRedPackParams {
  /* 红包数量 */
  number: number
  /* 标题 */
  title: string
  /* 币种合约地址 */
  tokenContract: string
  /* 币种类型 0 - ETH  1 - ERC20 */
  tokenType: 0 | 1
  /* 总金额 */
  totalToken: string
}

export class HappyRedPacketContract<
C = HappyRedPacket,
CT extends ContractType<C> = ContractType<C>
> extends ContractUtils<C> {
  contract: CT

  constructor (address: string, rpc: string) {
    super(ABI, rpc)

    this.contract = new Contract(address, ABI, this.provider) as CT
  }
}

export class RedPacketContract extends ethers.Contract {
  private _provider: ethers.providers.Web3Provider
  private providerSigner: ethers.providers.JsonRpcSigner
  private contract: string

  constructor (_provider: ethers.providers.Web3Provider, contract: string) {
    super(contract, ABI, _provider.getSigner())

    console.log(contract)

    this._provider = _provider
    this.providerSigner = _provider.getSigner()
    this.contract = contract
  }

  /**
   * 创建红包
   * @param params
   * @returns
   */
  async createRedPack (params: ICreateRedPackParams, decimal: number, balance: string) {
    const paramsData = [
      params.number,
      true,
      24 * 60 * 60,
      '',
      params.title,
      params.tokenType,
      params.tokenContract || `0x${'0'.repeat(40)}`,
      ethers.utils.parseUnits(params.totalToken, decimal)
    ] as any[]

    let value = '0'

    if (!params.tokenContract) {
      value = Tools.amountPlusDecimal(params.totalToken, decimal)
    }

    console.log(paramsData, value)

    const gasPrice = await this._provider.getGasPrice()

    // const nonce = await this._provider.getTransactionCount(this.providerSigner.getAddress())

    const inter = new ethers.utils.Interface(ABI)

    const data = inter.encodeFunctionData('create_red_packet', paramsData)

    const txData = {
      to: this.contract,
      data,
      value
      // nonce,
      // gasPrice
    }

    console.log(txData)

    const gasLimit = await this.providerSigner.estimateGas(txData)

    const gasLimitFloatRange = new BigNumber(gasLimit.toString()).multipliedBy(0.001).decimalPlaces(0, 1)

    // Gas Limit浮动值
    const gasLimitFloat = new BigNumber(gasLimit.toString()).plus(gasLimitFloatRange).toString()

    console.log('gasLimit', gasLimit.toString(), 'gasLimitFloat', gasLimitFloat.toString())

    if (!params.tokenContract) {
      const gas = new BigNumber(gasPrice.toString()).multipliedBy(gasLimitFloat).toString()

      // 手续费加红包金额
      const totalValue = new BigNumber(gas).plus(value).toString()

      // 如果手续费+金额大于余额
      if (new BigNumber(totalValue).gt(balance)) {
        // 余额 - 手续费
        // gasPrice * 21000
        value = new BigNumber(balance).minus(gas).toString()
      }

      paramsData[7] = value
    }

    paramsData.push({
      value,
      gasLimit: gasLimitFloat
    })

    console.log('paramsData', paramsData, 'value', value, 'balance', balance)

    return this.create_red_packet(
      ...paramsData
    )
  }

  /**
   * 回收红包
   */
  async refundRedPack (id: string) {
    const paramsData = [
      id
    ] as any[]

    const inter = new ethers.utils.Interface(ABI)

    const data = inter.encodeFunctionData('refund', paramsData)

    const txData = {
      to: this.contract,
      data,
      value: '0'
      // nonce,
      // gasPrice
    }

    console.log(txData)

    let gasLimitInit = '300000'

    try {
      const gasLimit = await this.providerSigner.estimateGas(txData)

      console.log('gasLimit', gasLimit)

      gasLimitInit = gasLimit.toString()
    } catch (error) {

    }

    paramsData.push({
      gasLimit: gasLimitInit
    })

    console.log('paramsData', paramsData)

    return this.refund(
      ...paramsData
    )
  }
}
